export interface IIntervalMarker {
    position: number;
    label: string;
    minutes: number;
}

const FIVE_MINUTES = 5;
const DAY_MINUTES = 1440;

export const adjustIntervalMarkers = (markers: IIntervalMarker[], isMini: boolean): IIntervalMarker[] => {
    const lastMarkerPosition = isMini ? 88 : 95;
    const fiveMinMarkerPosition = isMini ? 8 : 5;

    return markers.map((marker) => {
        if (marker.minutes === FIVE_MINUTES) {
            return {...marker, position: fiveMinMarkerPosition};
        }
        if (marker.minutes === DAY_MINUTES) {
            return {...marker, position: lastMarkerPosition};
        }
        return marker;
    });
};
